import { TelemetryService } from './service';
import { TelemetryServiceMock } from './service_mock';

let telemetryInstance: TelemetryService | null = null;

export function createTelemetryService(): TelemetryService {
  if (telemetryInstance) {
    return telemetryInstance;
  }

  // Always use mock service - GA4 tracking removed
  telemetryInstance = new TelemetryServiceMock();

  return telemetryInstance;
}

export { TelemetryService } from './service';
export type { TelemetryService as ITelemetryService };
